import _ from "lodash";
const percentageFormatter = new Intl.NumberFormat("de", {
    style: "percent",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
});
const numberFormatter = new Intl.NumberFormat("de", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
const intNumberFormatter = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0, minimumFractionDigits: 0 });
const moneyFormatters = {};
export const formatPercentage = (value) => {
    if (_.isNaN(value))
        value = 0;
    // avoid a -0 case, people get confused by this
    if (value === 0)
        value = 0;
    return percentageFormatter.format(value);
};
export const formatNumber = (value) => {
    if (_.isNaN(value))
        value = 0;
    // avoid a -0 case, people get confused by this
    if (value === 0)
        value = 0;
    return numberFormatter.format(value);
};
export const formatIntNumber = (value) => {
    if (_.isNaN(value))
        value = 0;
    // avoid a -0 case, people get confused by this
    if (value === 0)
        value = 0;
    return intNumberFormatter.format(value);
};
export const formatIntNumberRounded = (value) => {
    if (_.isNaN(value))
        value = 0;
    value = Math.round(value);
    // avoid a -0 case, people get confused by this
    if (value === 0)
        value = 0;
    return intNumberFormatter.format(value);
};
export const formatMoneyAmount = (value, currency) => {
    if (_.isNaN(value))
        value = 0;
    // avoid a -0 case, people get confused by this
    if (value === 0)
        value = 0;
    const key = (currency || "").toUpperCase();
    if (!moneyFormatters[key]) {
        moneyFormatters[key] = new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: key,
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        });
    }
    return moneyFormatters[key].format(value);
};
